import { useSelector } from 'react-redux';

function ListData() {
  const {
    listProcess, listTemplate, detailBs, processLevel, keyListProcessLevel, levelParent,
  } = useSelector((state) => ({
    listProcess: state?.business_process?.business_process?.map((value: any) => ({
      label: value.name,
      value: value.process_id,
      level: value.order?.split('.').length,
      type: value.type,
    })),
    listTemplate: state?.wla?.list_template,
    detailBs: state?.business_process?.detail,
    processLevel: state?.business_process?.process_level,
    keyListProcessLevel: state?.loading?.listKey?.listProcessLevel,
    levelParent: state?.business_process?.level,
  }));
  return {
    listProcess, listTemplate, detailBs, processLevel, keyListProcessLevel, levelParent,
  };
}

export default ListData;
